$ = require('jquery');

$(function(){

    var searchActive = false,
    $search = $('#search'),
    $searchInput = $search.find('input'),
    $searchButton = $search.find('.icon-search')
    ;

    function closeSearch(){
        $('body').removeClass('search_active');
        searchActive = false;
    }

    function openSearch(triggerFocus){
        $('body').addClass('search_active');
        searchActive = true;
        if(triggerFocus){
            $searchInput.focus();
        }
    }

    $search.on('submit', function(){
        $('body').addClass('loading');
    });

    $searchInput.on('focus', function(){
        if( !searchActive ){
            openSearch(false);
        }
        $searchInput.one('blur', function(e) {
            console.log(e);
            closeSearch();
        });
    });

    $searchButton.on('mousedown', function(e){

        e.preventDefault();
        $searchInput.off('blur');

        if( !searchActive ){
            openSearch(true);
        }else{
            //todo search by ajax? or just trigger a page spinner?
            var searchString = $searchInput.val();

            if( searchString.length === 0 ) {
                closeSearch();
            }else if( searchString.length > 3 ){
                var url = "/?s=" + searchString;
                $('body').addClass('loading');
                location.href = url;
            }else{
                $searchInput.focus();
            }
        }

    });




});